/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'

import { ViewModeEnum } from '@models/userMe'

import { useAuth } from '@modules/auth/contexts/AuthContext'

import StorageUtil, { StorageKeyEnum } from '@/utils/StorageUtil'

const AuthViewModeSwitcher: FC = () => {
  const { currentUser } = useAuth()

  const handleClick = (mode: ViewModeEnum) => {
    StorageUtil.set(StorageKeyEnum.ACTIVE_VIEW_MODE, mode)
    window.location.reload()
  }

  return (
    <div
      className="menu-item px-5"
      data-kt-menu-trigger="hover"
      data-kt-menu-placement="left-start"
      data-kt-menu-flip="bottom"
    >
      <a
        href="#"
        className="menu-link px-5"
      >
        <span className="menu-title position-relative">
          View Mode
          <span className="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0 text-capitalize">
            {currentUser?.active_view_mode?.toLowerCase()}
          </span>
        </span>
      </a>

      {currentUser?.view_modes?.length && currentUser.view_modes.length > 1 && (
        <div className="menu-sub menu-sub-dropdown w-175px fs-base py-4">
          {currentUser?.view_modes?.map((mode) => (
            <div
              className="menu-item px-3"
              key={mode}
            >
              <a
                href="#"
                onClick={() => handleClick(mode)}
                className={clsx('menu-link text-capitalize d-flex px-5', {
                  active: currentUser.active_view_mode === mode,
                })}
              >
                {mode.toLowerCase()}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export { AuthViewModeSwitcher }
